import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { container } from '../../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../../utils/container/service-ids';
import { FlagNames } from '../../../utils/feature-flags/flag-names';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type RequestEmailOtpAuthRequest = {
    email: string,
    locale: string
    current_entry_point: string
}

type RequestEmailOtpAuthSuccessResponse = {
    status: number
};

type RequestEmailOtpAuthErrorResponse = {
    message?: string,
    error: {
        message?: string
    }
};

export type RequestEmailOtpResponse = RequestEmailOtpAuthSuccessResponse | RequestEmailOtpAuthErrorResponse;

export function requestEmailOtpAuth(data: RequestEmailOtpAuthRequest): Promise<RequestEmailOtpResponse> {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

    if (!isHubApiEnabled) {
        return HubJsonRpcRequest.makeRequest<RequestEmailOtpResponse, RequestEmailOtpAuthRequest>(
            HubApiMethods.REQUEST_EMAIL_OTP_AUTH,
            data,
            window.app.deviceIdentifier
        );
    } else {
        const hubApi = getHubApi();
        return hubApi.requestEmailOtpAuth(window.app.deviceIdentifier, data) as Promise<RequestEmailOtpResponse>;
    }
}
